import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "successMessage", "errorMessage", "submit", "loading"]
  static values = { url: String }

  connect() {
    this.timeout = null
  }

  check() {
    clearTimeout(this.timeout)
    const username = this.inputTarget.value.trim()
    this.disableSubmit()

    if (username.length === 0) {
      this.clearMessage()
      this.enableSubmit()
      return
    }

    this.clearMessage()

    this.timeout = setTimeout(() => {
      this.performCheck(username)
    }, 500)
  }

  async performCheck(username) {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove("hidden")
    }

    try {
      const response = await fetch(`${this.urlValue}?username=${encodeURIComponent(username)}`, {
        headers: {
          "Accept": "application/json"
        }
      })
      
      if (this.inputTarget.value.trim() !== username) return

      if (response.ok) {
        const data = await response.json()
        if (this.inputTarget.value.trim() === username) {
          this.updateUI(data.available, data.error_message)
        }
      }
    } catch (error) {
      console.error("Error checking username:", error)
    } finally {
      if (this.hasLoadingTarget) {
        this.loadingTarget.classList.add("hidden")
      }
    }
  }

  updateUI(isAvailable, errorMessage) {
    if (isAvailable) {
      this.successMessageTarget.classList.remove("hidden")
      this.errorMessageTarget.classList.add("hidden")
      this.inputTarget.classList.remove("border-red-500", "focus:ring-red-500")
      this.inputTarget.classList.add("border-green-500", "focus:ring-green-500")
      this.enableSubmit()
    } else {
      this.successMessageTarget.classList.add("hidden")
      this.errorMessageTarget.classList.remove("hidden")
      
      const span = this.errorMessageTarget.querySelector('span')
      if (span) {
        span.textContent = errorMessage || "Username is taken"
      } else {
        this.errorMessageTarget.textContent = errorMessage || "Username is taken"
      }

      this.inputTarget.classList.remove("border-green-500", "focus:ring-green-500")
      this.inputTarget.classList.add("border-red-500", "focus:ring-red-500")
      this.disableSubmit()
    }
  }

  clearMessage() {
    this.successMessageTarget.classList.add("hidden")
    this.errorMessageTarget.classList.add("hidden")
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add("hidden")
    }
    this.inputTarget.classList.remove("border-red-500", "border-green-500", "focus:ring-red-500", "focus:ring-green-500")
  }

  disableSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.classList.add("opacity-50", "cursor-not-allowed")
    }
  }

  enableSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
      this.submitTarget.classList.remove("opacity-50", "cursor-not-allowed")
    }
  }
}
